import { render, staticRenderFns } from "./MenuGenerate.vue?vue&type=template&id=fe3c11b0"
import script from "./MenuGenerate.vue?vue&type=script&lang=js"
export * from "./MenuGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports